module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic4.c208865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic4.png
// module id = 587
// module chunks = 1